export enum actionTypes {
    ADD_TAGS = 'ADD_TAGS',
    APP_FETCH = 'APP_FETCH',
    SET_RG_CONFIG = 'SET_RG_CONFIG',
    TOGGLE_RECONNECT = 'TOGGLE_RECONNECT',
    UPDATE_MENU_ITEMS = 'UPDATE_MENU_ITEMS',
    SET_APP_ERROR = 'APP:ERROR:SET',
    UPDATE_HEADER_HEIGHT = 'UPDATE_HEADER_HEIGHT',
    UPDATE_OLD_GAMES_FEEDS = 'UPDATE_OLD_GAMES_FEEDS',
    UPDATE_LOTTO_ROOT_URL = 'UPDATE_LOTTO_ROOT_URL',
    UPDATE_SPORTSBOOK_ROOT_URL = 'UPDATE_SPORTSBOOK_ROOT_URL',
    TOGGLE_IS_APP_INIT_EXECUTED = 'TOGGLE_IS_APP_INIT_EXECUTED',
    SET_IGNORE_LOGOUT_NOTIFICATION = 'APP:IGNORE_LOGOUT_NOTIFICATION:SET',
    SET_IS_QUICK_DEPOSIT_AVAILABLE = 'SET_IS_QUICK_DEPOSIT_AVAILABLE',
    SET_IS_INTEGRATION_SCRIPT_LOADED = 'APP:SET_IS_INTEGRATION_SCRIPT_LOADED',
    TOGGLE_IS_CHANGE_LANG_IN_PROGRESS = 'APP:IS_CHANGE_LANG_IN_PROGRESS:TOGGLE'
}

// default values
export const DATE_FORMAT = 'YYYY-MM-DD';
export const TIME_FORMAT = '24-hour';
export const NUMBER_SEPARATOR = '0,000.00';
export const CURRENCY_SYMBOL_POSITION = 'onTheLeft';
